import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Social Media Icons */}
        <div className="social-icons">
          <a href="https://github.com/denden09" aria-label="GitHub">
            <i className="bx bxl-github"></i>
          </a>
          <a href="https://www.linkedin.com/in/vinsensius-arden-a8297b253/" aria-label="LinkedIn">
            <i className="bx bxl-linkedin"></i>
          </a>
          <a href="https://www.instagram.com/v.ardn/" aria-label="Instagram">
            <i className="bx bxl-instagram"></i>
          </a>
          <a href="#" aria-label="Twitter">
            <i className="bx bxl-twitter"></i>
          </a>
        </div>

        {/* Footer Navigation Links */}
        <ul className="list">
          <li><a href="#">FAQ</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#about">About Me</a></li>
          <li><a href="#projects">My Works</a></li>
        </ul>

        {/* Copyright */}
        <p className="copyright">© Arden | All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
